import { getTooltipAttributes } from "@common/contexts/Tooltip";
import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import classNames from "classnames";
import React from "react";

import "./style.less";

export type BadgeProps = {
  className?: string;
  color?: string;
  icon?: IconType;
  title?: string;
  children?: any;
  style?: React.CSSProperties;
  tooltip?: string;
  tooltipDelay?: number;

  onClose?: () => void;
  onClick?: () => void;
};
const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>((props, ref) => (
  <span
    className={classNames("badge", props.color ?? "gray", props.className)}
    onClick={props.onClick}
    ref={ref}
    style={props.style}
    {...getTooltipAttributes(props.tooltip, { delay: props.tooltipDelay })}
  >
    {!!props.icon && <Icon icon={props.icon} />}
    {(!!props.children || props.children === 0) && (
      <span className="content single-line-ellipsis" title={props.title}>
        {props.children}
      </span>
    )}
    {!!props.onClose && (
      <Icon
        className="right"
        icon={IconType.Cross}
        onClick={props.onClose ? (e) => (e.stopPropagation(), props.onClose!()) : undefined}
      />
    )}
  </span>
));
export default Badge;
